import React, { useEffect, useState } from "react";
import Images from "../../assets/images/index";
import Icons from "../../assets/icons/index";
import {
  ApiUrl,
  EditProfileDetail,
  getCountryStateCityData,
  getCountryStateCityList,
  getCurrent,
  token,
} from "../../restApi/api";
import { firebaseData } from "../../firebase";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { decrypt, encrypt } from "../../utils/crypto";
import { authorizationCheck } from "../../utils/logout";
import Loader from "../common/Loader/Loader";
import { trackEvent } from "../../utils/moengageUserSetup";

const INITIAL_STATE = {
  id: "",
  name: "",
  email: "",
  mobileNo: "",
  country: "",
  collegeCity: "",
  collegeName: "",
  collegeYear: "",
  collegeState: "",
  avatar: "",
  batch: "",
  preparingFor: "",
};

export default function EditProfile() {
  const navigate = useNavigate();
  const [config, setConfig] = useState();
  const [remoteLoading, setRemoteLoading] = useState(true);
  const [country, setCountry] = useState(null);
  const [state, setState] = useState(null);
  const [city, setCity] = useState(null);
  const [college, setCollege] = useState(null);
  const [collegeYear, setCollegeYear] = useState(null);
  const [current, setCurrent] = useState(null);
  const [getProfileDetails, profileDetails] = useState(INITIAL_STATE);
  const [countryId, setcountryId] = useState(null);
  const [stateId, setStateId] = useState(null);
  const [cityId, setCityId] = useState(null);
  const [file, setFile] = useState("");
  let [loader, setloader] = useState(false);
  const [constantConfigData, setconstantConfigData] = useState(null);
  const [NoteVisibility, setNoteVisibility] = useState(false);
  const [courseName, setCourseName] = useState(getProfileDetails?.preparingFor);
  const [collegeLocked, setCollegeLocked] = useState(false);
  const getCountry = async () => {
    const data = {
      country: "",
      state: "",
      city: "",
      courses: getProfileDetails?.preparingFor,
    };
    await getCountryStateCityData(data)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        setCountry(data);
        // setState('')
        // setCity('')
        setCollege("");
      });
  };
  const currentUser = async () => {
    await getCurrent()
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        let req = JSON.parse(decrypt(data));
      })
      .catch((error) => { });
  };
  const selectData = async () => {
    profileDetails({
      ...getProfileDetails,
      collegeName: "",
    });
  };

  const selectCountry = async (slctCountry) => {
    profileDetails({
      ...getProfileDetails,
      country: slctCountry ? slctCountry.target.value : countryId,
      collegeState: "",
      collegeCity: "",
      collegeName: "",
    });
    const data = {
      country: slctCountry ? slctCountry.target.value : countryId,
      state: "",
      city: "",
      courses: getProfileDetails?.preparingFor,
    };
    await getCountryStateCityList(data)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        // setStateId(data.data.result.states[0]._id)
        if (data.data.result?.states) {
          setState(data);
          // setCity(null)
          setCollege(null);
          return;
        }
        setState(null);
        setCity(null);
        setCollege(null);
        return;
      });
  };

  // console.log(state,city,"api");

  const selectState = async (slctState) => {
    profileDetails({
      ...getProfileDetails,
      collegeState: slctState ? slctState.target.value : stateId,
      collegeCity: "",
      collegeName: "",
      collegeYear: "",
      batch: "",
    });
    const data = {
      country: "",
      state: slctState ? slctState.target.value : stateId,
      city: "",
      courses: getProfileDetails?.preparingFor,
    };
    await getCountryStateCityList(data)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.data.result?.city) {
          setCity(data);
          setCollege(null);
          return;
        }
        setCity(null);
        setCollege(null);
        return;
      });
  };

  const selectCity = async (slctCity) => {
    profileDetails({
      ...getProfileDetails,
      collegeCity: slctCity ? slctCity.target.value : cityId,
    });
    const data = {
      country: "",
      state: "",
      city: slctCity ? slctCity.target.value : cityId,
      courses: getProfileDetails?.preparingFor,
    };
    await getCountryStateCityList(data)
      .then((response) => {
        return response.json();
      })
      .then((data) => {
        if (data.data.result?.colleges) {
          setCollege(data);
          setCollegeYear(data);
          return;
        }
        setCollege(null);
        setCollegeYear(null);
        return;
      });
  };

  useEffect(() => {
    const getConfigData = async () => {
      try {
        const remoteData = await firebaseData("settings_config"); // Replace 'your_config_key' with the actual key for the configuration value you want
        setConfig(JSON.parse(remoteData));
        const constantConfigData = await firebaseData("constants_text"); // Replace 'your_config_key' with the actual key for the configuration value you want
        setconstantConfigData(JSON.parse(constantConfigData));
        setRemoteLoading(false);
      } catch (error) {
        console.error("Error fetching remote data:", error);
        setRemoteLoading(false);
      }
    };

    if (typeof window !== "undefined") {
      getConfigData();
    }
  }, []);

  const currentList = async () => {
    setloader(true);
    let user = localStorage.getItem("profileDetails");
    user = JSON.parse(decrypt(user));
    const isCollegeLocked = await firebaseData("collegeLocked");
    let collegeLockedFromConfig = JSON.parse(isCollegeLocked);
    setCollegeLocked(collegeLockedFromConfig);
    if (collegeLockedFromConfig) {
      if (
        user &&
        user.country &&
        user.collegeState &&
        user.collegeCity &&
        user.collegeName &&
        user.batch &&
        user.collegeYear
      ) {
        setNoteVisibility(true);
      } else {
        setNoteVisibility(false);
      }
    } else {
      setNoteVisibility(false);
    }
    // console.log(collegeLocked,"cccccccccccccccccccccccccccccc");

    profileDetails({
      ...getProfileDetails,
      id: user.id,
      name: user.name,
      avatar: user.avatar,
      country: user.country,
      email: user.email,
      collegeCity: user.collegeCity,
      collegeName: user.collegeName,
      collegeState: user.collegeState,
      collegeYear: user.collegeYear,
      batch: user.batch,
      mobileNo: user.mobileNo,
      preparingFor: user.preparingFor,
    });
    // console.log(user,"user")
    setcountryId(user.country);
    setStateId(user.collegeState);
    setCityId(user.collegeCity);
    setFile(user.avatar);
    setloader(false);
  };

  const handleInputChange = function (fieldValue, fieldName) {
    profileDetails({ ...getProfileDetails, [fieldName]: fieldValue });
  };

  const setAvatar = async (e) => {
    const selectedFile = e[0];

    if (
      selectedFile &&
      (selectedFile.type === "image/png" ||
        selectedFile.type === "image/jpeg" ||
        selectedFile.type === "image/jpg")
    ) {
      profileDetails({
        ...getProfileDetails,
        avatar: e[0],
      });
      setFile(URL.createObjectURL(e[0]));
    } else {
      // Display an error message or take appropriate action
      toast.error("Please select a PNG or JPG image.");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (
      getProfileDetails.name == "" ||
      getProfileDetails.country == "" ||
      getProfileDetails.collegeCity == "" ||
      getProfileDetails.collegeState == "" ||
      getProfileDetails.collegeName == "" ||
      getProfileDetails.collegeYear == "" ||
      getProfileDetails.batch == "" ||
      getProfileDetails.preparingFor == ""
    ) {
      toast.error("All field are required");
      return;
    } else {
      let formData = new FormData();
      formData.append("id", getProfileDetails.id);
      formData.append("name", getProfileDetails.name);
      formData.append("mobileNo", getProfileDetails.mobileNo);
      formData.append("email", getProfileDetails.email);
      formData.append("country", getProfileDetails.country);
      formData.append("collegeCity", getProfileDetails.collegeCity);
      formData.append("collegeName", getProfileDetails.collegeName);
      formData.append("collegeState", getProfileDetails.collegeState);
      formData.append("collegeYear", getProfileDetails.collegeYear);
      formData.append("batch", getProfileDetails.batch);
      formData.append("preparingFor", courseName);
      if (getProfileDetails.avatar?.name) {
        formData.append("avatar", getProfileDetails.avatar);
      }
      setloader(true);
      const res = await EditProfileDetail(formData)
        .then((response) => {
          return response.json();
        })
        .then((req) => {
          // let req= JSON.parse(decrypt(data))
          if (req.data.code == 1) {
            setloader(false);
            // setTimeout(() => {
            //     toast.success('Profile Updated Successfully')
            // },300);
            trackEvent("profileUpdated", { "source": "web", "course": getProfileDetails.preparingFor, "prof": 1, "batch": getProfileDetails.batch });

            currentUser();
            navigate("/account");
            currentList();
          } else if (req.data.code == 402) {
            setloader(false);
            authorizationCheck(navigate);
          } else if (req.data.code == 500) {
            setloader(false);
            toast.error(req.data.message);
          }
        })
        .catch((err) => {
          setloader(false);
        });
    }
  };
  const courseFunction = async (name, value) => {
    if (value == "preparingFor") {
      setCourseName(name);
      getProfileDetails.preparingFor = name;
    }
    handleInputChange(value, name);
    if (!collegeLocked) {
      // handleInputChange('', 'collegeName');
      getProfileDetails.country = "";
      getProfileDetails.collegeState = "";
      getProfileDetails.collegeCity = "";
      getProfileDetails.collegeName = "";
      getProfileDetails.collegeYear = "";
      getProfileDetails.batch = "";
      selectData();
      // selectCountry()
      // selectState()
      // selectCity()
      // console.log({getProfileDetails})
    }
  };
  useEffect(() => {
    currentList();
    getCountry();
  }, []);

  const getText = () => {
    if (collegeLocked) {
      if (NoteVisibility) {
        return constantConfigData?.edit_time_alert;
      } else {
        return constantConfigData?.register_time_alert;
      }
    } else {
      return "";
    }
  };
  // get state according to company
  useEffect(() => {
    countryId && selectCountry();
  }, [countryId]);

  useEffect(() => {
    stateId && selectState();
  }, [stateId]);

  useEffect(() => {
    cityId && selectCity();
  }, [cityId]);

  if (loader) {
    return (
      <>
        <Loader></Loader>
      </>
    );
  }
  if (!loader) {
    return (
      <div className="main_wrapper">
        <div className="breadcrumbs">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a>Home</a>
            </li>
            <li className="breadcrumb-item">
              <a>Account</a>
            </li>
            <li className="breadcrumb-item active">
              <a>Edit Profile</a>
            </li>
          </ul>
        </div>
        <section className="videoLayer_wrapper account_main_wrapper editProfile_wrapper section_side_padding">
          <div className="row">
            <div className="col-lg-8 col-md-7 col-sm-12">
              <form
                onSubmit={(e) => {
                  handleSubmit(e);
                }}
              >
                <div className="subjects_wrapper">
                  <div className="setting_ttl_wrapper d-flex align-items-center">
                    <figure className="sett_back_arrow">
                      <Link to={"/account"}>
                        <img
                          src={Icons.BackArrow}
                          alt=""
                          className="img-fluid"
                        />
                      </Link>
                    </figure>
                    <div className="sett_ttl">
                      <h5>Profile</h5>
                    </div>
                  </div>
                  <div className="user_info_wrappper">
                    <div className="user_inner_info">
                      <figure className="user_img pos_rel">
                        <img
                          src={file ? file : Icons.UserPic}
                          alt=""
                          className="img-fluid"
                          accept=".png, .jpg, .jpeg"
                        />
                        <input
                          type="file"
                          accept=".png, .jpg, .jpeg"
                          className="profile_upload"
                          onChange={(e) => setAvatar(e.target.files, "avatar")}
                        />
                        <figcaption className="camera_position">
                          <span className="camera_circle">
                            <img
                              src={Icons.Camera}
                              alt=""
                              className="img-fluid"
                            />
                            <input
                              type="file"
                              accept=".png, .jpg, .jpeg"
                              className="file_upload"
                              onChange={(e) =>
                                setAvatar(e.target.files, "avatar")
                              }
                            />
                          </span>
                        </figcaption>
                      </figure>
                    </div>
                  </div>
                  <div className="personal_details_wrapper">
                    <div className="user_info_wrappper information_options">
                      <h5>Personal Details</h5>
                    </div>
                    <div className="edit_profile_details">
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="form-group">
                            <label>Full name</label>
                            {
                              <input
                                type="text"
                                className="form-control"
                                style={{
                                  border:
                                    getProfileDetails.name == ""
                                      ? "1px solid red"
                                      : "",
                                }}
                                onChange={(e) =>
                                  handleInputChange(
                                    e.target.value.trimStart(),
                                    "name"
                                  )
                                }
                                value={getProfileDetails.name ?? ""}
                              />
                            }
                            {getProfileDetails.name == "" && (
                              <span
                                style={{ color: "#DC3F16", fontSize: "12px" }}
                              >
                                name is required
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="form-group">
                            <label>Mobile number</label>
                            <input
                              type="tel"
                              className="form-control"
                              onChange={(e) =>
                                handleInputChange(e.target.value, "mobileNo")
                              }
                              value={getProfileDetails.mobileNo}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="form-group">
                            <label>Email address</label>
                            <input
                              type="email"
                              className="form-control"
                              onChange={(e) =>
                                handleInputChange(e.target.value, "email")
                              }
                              value={getProfileDetails.email}
                              disabled
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="personal_details_wrapper center_margin">
                    <div className="user_info_wrappper information_options">
                      <h5>Course Details</h5>
                      <p>{getText()}</p>
                    </div>
                    <div className="edit_profile_details">
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="form-group">
                            <label>Enrolled course</label>
                            <select
                              name=""
                              id=""
                              className="form-control custom_select"
                              style={{
                                border:
                                  getProfileDetails.preparingFor == ""
                                    ? "1px solid red"
                                    : "",
                              }}
                              onChange={(e) =>
                                courseFunction(e.target.value, "preparingFor")
                              }
                            >
                              <option value="">Select Course</option>
                              {config &&
                                config.courses.map((d, i) => (
                                  <option
                                    value={d.title}
                                    selected={
                                      getProfileDetails.preparingFor === d.title
                                    }
                                  >
                                    {d.title}
                                  </option>
                                ))}
                              {/* <option value="">MCI Screening</option> */}
                            </select>
                            {getProfileDetails.preparingFor == "" && (
                              <span
                                style={{ color: "#DC3F16", fontSize: "12px" }}
                              >
                                course is required
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="personal_details_wrapper">
                    <div className="user_info_wrappper information_options">
                      <h5>College Details</h5>
                    </div>
                    <div className="edit_profile_details">
                      <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="form-group">
                            <label>Country</label>
                            <select
                              name=""
                              id=""
                              style={{
                                border:
                                  getProfileDetails.country == ""
                                    ? "1px solid red"
                                    : "",
                              }}
                              onChange={(event) => selectCountry(event)}
                              className="form-control custom_select"
                              disabled={NoteVisibility}
                              value={getProfileDetails.country}
                            >
                              <option value="">Select country</option>
                              {country &&
                                country.data.result.countries.map((d, i) => (
                                  <option
                                    value={d._id}
                                  // selected={getProfileDetails.country && getProfileDetails.country === d._id}
                                  >
                                    {d.title}
                                  </option>
                                ))}
                            </select>
                            {getProfileDetails.country == "" && (
                              <span
                                style={{ color: "#DC3F16", fontSize: "12px" }}
                              >
                                country is required
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12">
                          <div className="form-group">
                            <label>State</label>
                            <select
                              name=""
                              id=""
                              style={{
                                border:
                                  getProfileDetails.collegeState == ""
                                    ? "1px solid red"
                                    : "",
                              }}
                              onChange={(event) => selectState(event)}
                              className="form-control custom_select"
                              placeholder="select state"
                              disabled={NoteVisibility}
                              value={getProfileDetails.collegeState}
                            >
                              <option value="">Select state</option>
                              {state &&
                                state.data &&
                                state.data.result.states.map((d, i) => (
                                  <option
                                    value={d._id}
                                  // selected={getProfileDetails.collegeState && getProfileDetails.collegeState === d._id}
                                  >
                                    {d.title}
                                  </option>
                                ))}
                            </select>
                            {getProfileDetails.collegeState == "" && (
                              <span
                                style={{ color: "#DC3F16", fontSize: "12px" }}
                              >
                                college state is required
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12">
                          <div className="form-group">
                            <label>City</label>
                            <select
                              name=""
                              id=""
                              style={{
                                border:
                                  getProfileDetails.collegeCity == ""
                                    ? "1px solid red"
                                    : "",
                              }}
                              onChange={(event) => selectCity(event)}
                              className="form-control custom_select"
                              disabled={NoteVisibility}
                              value={getProfileDetails.collegeCity}
                            >
                              <option value="" selected>
                                Select city
                              </option>
                              {city != null &&
                                city.data &&
                                city.data.result.city.map((d, i) => (
                                  <option
                                    value={d._id}
                                  // selected={getProfileDetails.collegeCity && getProfileDetails.collegeCity === d._id}
                                  >
                                    {d.title}
                                  </option>
                                ))}
                            </select>
                            {getProfileDetails.collegeCity == "" && (
                              <span
                                style={{ color: "#DC3F16", fontSize: "12px" }}
                              >
                                college city is required
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                          <div className="form-group">
                            <label>College name</label>
                            <select
                              name=""
                              id=""
                              style={{
                                border:
                                  getProfileDetails.collegeName == ""
                                    ? "1px solid red"
                                    : "",
                              }}
                              className="form-control custom_select"
                              onChange={(e) =>
                                handleInputChange(e.target.value, "collegeName")
                              }
                              disabled={NoteVisibility}
                              value={getProfileDetails.collegeName}
                            >
                              <option value="">Select College Name</option>
                              {college &&
                                college.data &&
                                college.data.result.colleges.map((d, i) => (
                                  <option
                                    value={d._id}
                                  // selected={getProfileDetails.collegeName && getProfileDetails.collegeName === d._id}
                                  >
                                    {d.title}
                                  </option>
                                ))}
                            </select>
                            {getProfileDetails.collegeName == "" && (
                              <span
                                style={{ color: "#DC3F16", fontSize: "12px" }}
                              >
                                college name is required
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12">
                          <div className="form-group">
                            <label>College year</label>
                            <select
                              name=""
                              id=""
                              style={{
                                border:
                                  getProfileDetails.collegeYear == ""
                                    ? "1px solid red"
                                    : "",
                              }}
                              className="form-control custom_select"
                              onChange={(e) =>
                                handleInputChange(e.target.value, "collegeYear")
                              }
                              disabled={NoteVisibility}
                              value={getProfileDetails.collegeYear}
                            >
                              <option value="">Select Year</option>
                              {collegeYear &&
                                collegeYear.data &&
                                collegeYear.data.result.collegeYear.map(
                                  (d, i) => (
                                    <option
                                      value={d.title}
                                    //  selected={getProfileDetails.collegeYear === d.title}
                                    >
                                      {d.title}
                                    </option>
                                  )
                                )}
                            </select>
                            {getProfileDetails.collegeYear == "" && (
                              <span
                                style={{ color: "#DC3F16", fontSize: "12px" }}
                              >
                                college year is required
                              </span>
                            )}
                          </div>
                        </div>
                        <div className="col-lg-3 col-md-3 col-sm-12">
                          <div className="form-group">
                            <label>College batch</label>
                            <select
                              name=""
                              id=""
                              style={{
                                border:
                                  getProfileDetails.batch == ""
                                    ? "1px solid red"
                                    : "",
                              }}
                              className="form-control custom_select"
                              onChange={(e) =>
                                handleInputChange(e.target.value, "batch")
                              }
                              disabled={NoteVisibility}
                              value={getProfileDetails.batch}
                            >
                              <option value="">Select Batch</option>
                              {config &&
                                config?.batches.map((d, i) => (
                                  <option
                                    value={d._id}
                                  //  selected={getProfileDetails.batch === d._id}
                                  >
                                    {d.year}
                                  </option>
                                ))}
                            </select>
                            {getProfileDetails.batch == "" && (
                              <span
                                style={{ color: "#DC3F16", fontSize: "12px" }}
                              >
                                batch is required
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="update_profile_btn text-center">
                  <button className="btn btn_update" type="submit">
                    Update Profile
                  </button>
                  <ToastContainer />
                </div>
              </form>
            </div>
          </div>
        </section>
      </div>
    );
  }
}
